const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7×24小时全天候内容监控，重大事件30分钟内上线，热点绝不漏过。编辑团队实时追踪全网动态，确保您看到的每一条黑料都是最新鲜的第一手资讯。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '信息可靠',
    desc: '多渠道交叉验证，确保每一条爆料的真实性和可信度。我们拥有专业的编辑审核团队，所有发布内容均经过严格的事实核查流程，杜绝虚假信息传播。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '完美适配手机、平板、电脑等全部设备，无需下载APP即可流畅浏览。支持浏览器直接访问，随时随地想看就看，不受设备限制。',
  },
  {
    icon: 'ri-lock-line',
    title: '安全私密',
    desc: '采用先进的隐私保护技术，浏览记录不泄露、个人信息不外传。所有爆料人信息严格加密存储，确保每一位用户和爆料人的隐私安全得到最大程度的保护。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            ✨ 平台优势
          </h2>
          <p className="text-sm text-foreground-600">
            为什么选择91黑料？四大核心优势为您保驾护航
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/60 rounded-xl p-6 text-center hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="w-14 h-14 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-primary-600 text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}